module.exports = "/assets/data/4b7f8b99e4589f8623fe923e2313836e-HD4.data.json";